import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/blog/components/BlogPostContentGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/components/ContactInquiryPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Products/FaqEnquiryGrid.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/CmsImage.tsx");
